import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const HashScroll = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) return undefined;
    const id = hash.slice(1);
    let cancelled = false;
    let observer = null;
    let endTimer = null;

    const align = (behavior) => {
      const el = document.getElementById(id);
      if (!el) return;
      const margin = parseFloat(getComputedStyle(el).scrollMarginTop) || 0;
      if (Math.abs(el.getBoundingClientRect().top - margin) > 8) {
        el.scrollIntoView({ behavior, block: 'start' });
      }
    };

    const stop = () => {
      cancelled = true;
      if (observer) observer.disconnect();
      if (endTimer) clearTimeout(endTimer);
      window.removeEventListener('wheel', stop);
      window.removeEventListener('touchstart', stop);
    };

    // User taking over scrolling cancels further corrections.
    window.addEventListener('wheel', stop, { passive: true });
    window.addEventListener('touchstart', stop, { passive: true });

    const startTimer = setTimeout(() => {
      if (cancelled) return;
      align('smooth');
      // Re-correct whenever late-loading images/sections shift the layout.
      let first = true;
      observer = new ResizeObserver(() => {
        if (first) { first = false; return; }
        if (!cancelled) align('auto');
      });
      observer.observe(document.body);
      endTimer = setTimeout(stop, 3000);
    }, 150);

    return () => {
      clearTimeout(startTimer);
      stop();
    };
  }, [pathname, hash]);

  return null;
};

export default HashScroll;
